// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"791b53f1","62":"9a586e4e"}[chunkId] + ".chunk.js";
};